import React, { useEffect, useRef, useState } from 'react'
import { CForm, CFormInput, CFormLabel, CRow, CCol, CButton, CCardText } from '@coreui/react';
import { Typeahead } from 'react-bootstrap-typeahead';
import CookieFunctions from '../functions/CookieFunctions';
import AdminSummary from '../components/timeOff/AdminSummary';
import AdminAllRequests from '../components/timeOff/AdminAllRequests';

export default function AdminSearch() {
    const [driver, setDriver] = useState(null)
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [driverId, setDriverId] = useState(null);

    const search = useRef();

    useEffect(() => {
        fetchDrivers();
    }, []);

    const fetchDrivers = () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/admin/driver", {
            headers: myHeaders,
            method: 'GET'
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error();
                }
            })
            .then((data) => {
                setOptions(data);
                setIsLoading(false);
            })
            .catch((e) => {
                setError("Error occurred while fetching drivers.");
                setIsLoading(false);
            });
    };


    const handleSelection = (selected) => {
        if (selected.length === 1) {
            setDriver(selected);
            setDriverId(selected[0].mpp_id);
        }
    };

    return (
        <>
            <CForm className='fs-4'>
                <CCol sm="5" xs="6">
                    <CFormLabel className='fs-4'>Search by Driver Name</CFormLabel>
                    <Typeahead
                        id="manager-search"
                        isLoading={isLoading}
                        labelKey={option => `${option.mpp_firstname} ${option.mpp_lastname} (${option.mpp_id})`}
                        onChange={handleSelection}
                        options={options}
                        ref={search}
                    />
                </CCol>
                {error && <p>{error}</p>}
            </CForm>
            <br />

            {driver ? <>
                <AdminSummary driver={driver} />
                <AdminAllRequests driver={driver} />
            </> : null}

        </>
    )
}